module.exports = __webpack_public_path__ + "static/media/bipbip2.b444a161.png";